<div class="mub-confirm-dialog position-relative">
  <div
    *ngIf="showCloseButton"
    class="cross-ics-member pstn-absolute right--14 top--24 mt-2 z-ex"
    (click)="onClose()"
  >
    <img
      alt="cross icon"
      src="../../../../assets/images/crossblack.svg"
      width="24px"
      height="24px"
      class="module-screen-icon"
    />
  </div>
  <h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
  <mat-dialog-content>
    <p [innerHTML]="message"></p>
    <p *ngIf="note !== ''" class="cmn-txt cmn-txt-sm mb-0 note-text-cls">
      <span [innerHTML]="note"></span>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="btn cancel-co-member-modal button-cancel me-2 btn-cls"
      tabindex="-1"
      (click)="onCancelClick()"
    >
      {{ cancelButtonText }}
    </button>
    <button
    class="btn btn--primary btn-cls"
      (click)="onConfirmClick()"
      tabindex="1"
    >
      {{ confirmButtonText }}
    </button>
  </mat-dialog-actions>
</div>
